import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PlaceholderPage } from '@/components/layout/PlaceholderPage';

export const Route = createFileRoute('/_app/providers')({
	component: ProvidersRoute,
});

function ProvidersRoute() {
	const { t } = useTranslation();
	return (
		<PlaceholderPage
			title={t('nav.providers')}
			description={t('placeholder.providers.description')}
			scope={t('placeholder.providers.scope')}
		/>
	);
}
